import React, {useEffect, useState, useRef} from 'react';
import Button from "../button";
import Input from "../input";
import styles from './resultForm.module.css';
import {Link} from "react-router-dom";
import universalGTM from "../test/handleAnalytics";

export const ResultForm = ({mailchimpTag, quizName}) => {
    const [data, setData] = useState({
    });

    const [validate, setValidate] = useState({
        email: true
    });

    const form = useRef(null)

    useEffect(() => {
        setData({
            Email: '',
            tag: mailchimpTag
        })
    }, []);

    const onSubmitForm = (e) => {
        e.preventDefault();
        const formData = new FormData(form.current);
        if (data.Email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
            setValidate({
                email: true
            })
        } else {
            setValidate({
                email: false
            });
            return false
        }

        fetch("https://ppc.world/public_api/tag/send/", {
            method: 'POST',
            body: formData,
            mode: 'no-cors'
        }).then((res) => {
            if(window.location.hostname !== 'localhost') {
                universalGTM({
                    'event_action': `Тест ${quizName}`,
                    'event_label': 'Оставил свою почту'
                });
            }
            form.current.innerHTML = 'Спасибо! На указанный email придет письмо'
        })
    };

    return (
        <form onSubmit={onSubmitForm} ref={form} className={styles.form}>
            <input type="email" name="Email" required onChange={e => {
                setData({
                    Email: e.target.value,
                    tag: mailchimpTag
                })
            }
            }
                   className={`${styles.input} ${validate.email === true ? '' : styles.error}`}
                   placeholder="Email"/>
            <input type="hidden" name="tag" tabIndex="-1" value={mailchimpTag} />
            <input type="submit" value="Отправить" className={styles.button}/>
            <div className={styles.text}>Нажимая на кнопку, вы даете согласие на <a href="https://ppc.world/files/mailing_consent.pdf" target="_blank">обработку персональных данных</a></div>
        </form>
    )
};